import { ReactNode, useContext } from 'react';

import Container from './container';
import styles from './styles.module.scss';
import SubCategoryContext from './SubCategoryContext';

interface Props {
    children?: ReactNode;
    value: string;
}

function SubCategory({ children, value: localValue }:Props) {
  const { value, setValue, isColorful } = useContext(SubCategoryContext);
  const isActive = localValue === value;
  return (
      <button className={`${styles.button} ${isActive ? styles.active : ''} ${isColorful ? styles.colorful : ''}`}
              type='button'
              onClick={() => setValue(localValue)} >
          {children}
      </button>
  );
}

SubCategory.Container = Container;

export default SubCategory;
